import { customParams, pageDefaults } from './util';
import { SegmentMetrics } from './segment';

export const segmentClient = new SegmentMetrics();

export default {
  vendors: [
    {
      api: segmentClient,
    },
  ],
  pageDefaults,
  customParams,
  cancelOnNext: false,
};
